module.exports = "/shared/img/rubbish-blue.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/rubbish-blue.svg
// module id = 445
// module chunks = 13